import { Navigate, Route, Routes } from 'react-router-dom'

import { ForgotPassword } from '../../../pages/painel/ForgotPassword'
import { Login } from '../../../pages/painel/Login'
import { RegisterPassword } from '../../../pages/painel/RegisterPassword'
import { ResetPassword } from '../../../pages/painel/ResetPassword'
import { Root } from './Root'

export const PainelAuthRoutes = () => {
  return (
    <Routes>
      <Route element={<Root />}>
        <Route path="login" element={<Login />} />
        <Route path="forgot-password" element={<ForgotPassword />} />
        <Route path="reset-password" element={<ResetPassword />} />
        <Route path="register-password" element={<RegisterPassword />} />
        <Route path="*" element={<Navigate to={'/painel'} />} />

        <Route index element={<Login />} />
      </Route>
    </Routes>
  )
}
